"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELIVERY_HEALTH_SEVERITY = exports.DeliveryFunnelGate = exports.DeliverySlaSource = exports.DeliveryDatasheetCoverageJudgment = exports.DeliverySlaJudgment = void 0;
exports.deliveryHealthSeverity = deliveryHealthSeverity;
exports.isDeliverySlaJudgment = isDeliverySlaJudgment;
exports.isDeliveryFunnelGate = isDeliveryFunnelGate;
exports.isDeliveryHealthReason = isDeliveryHealthReason;
exports.isDeliverySlaSource = isDeliverySlaSource;
exports.isDeliveryDatasheetCoverageJudgment = isDeliveryDatasheetCoverageJudgment;
const pipeline_ops_1 = require("./pipeline-ops");
var DeliverySlaJudgment;
(function (DeliverySlaJudgment) {
    DeliverySlaJudgment["NotStarted"] = "not_started";
    DeliverySlaJudgment["OnTrack"] = "on_track";
    DeliverySlaJudgment["AtRisk"] = "at_risk";
    DeliverySlaJudgment["Breached"] = "breached";
})(DeliverySlaJudgment || (exports.DeliverySlaJudgment = DeliverySlaJudgment = {}));
var DeliveryDatasheetCoverageJudgment;
(function (DeliveryDatasheetCoverageJudgment) {
    DeliveryDatasheetCoverageJudgment["NotCounted"] = "not_counted";
    DeliveryDatasheetCoverageJudgment["Met"] = "met";
    DeliveryDatasheetCoverageJudgment["BelowTarget"] = "below_target";
})(DeliveryDatasheetCoverageJudgment || (exports.DeliveryDatasheetCoverageJudgment = DeliveryDatasheetCoverageJudgment = {}));
var DeliverySlaSource;
(function (DeliverySlaSource) {
    DeliverySlaSource["OrgOverride"] = "org_override";
    DeliverySlaSource["Default"] = "default";
})(DeliverySlaSource || (exports.DeliverySlaSource = DeliverySlaSource = {}));
var DeliveryFunnelGate;
(function (DeliveryFunnelGate) {
    DeliveryFunnelGate["Green"] = "green";
    DeliveryFunnelGate["Yellow"] = "yellow";
    DeliveryFunnelGate["Blue"] = "blue";
    DeliveryFunnelGate["Empty"] = "empty";
})(DeliveryFunnelGate || (exports.DeliveryFunnelGate = DeliveryFunnelGate = {}));
exports.DELIVERY_HEALTH_SEVERITY = [
    pipeline_ops_1.DeliveryHealthReason.Blocked,
    pipeline_ops_1.DeliveryHealthReason.Breached,
    pipeline_ops_1.DeliveryHealthReason.AtRisk,
    pipeline_ops_1.DeliveryHealthReason.Stalled,
    pipeline_ops_1.DeliveryHealthReason.TimedOut,
    pipeline_ops_1.DeliveryHealthReason.CreditRequired,
    pipeline_ops_1.DeliveryHealthReason.Quiet,
    pipeline_ops_1.DeliveryHealthReason.StageOverdue,
    pipeline_ops_1.DeliveryHealthReason.Good,
    pipeline_ops_1.DeliveryHealthReason.Abandoned,
];
function deliveryHealthSeverity(reason) {
    return exports.DELIVERY_HEALTH_SEVERITY.indexOf(reason);
}
function isDeliverySlaJudgment(value) {
    return Object.values(DeliverySlaJudgment).includes(value);
}
function isDeliveryFunnelGate(value) {
    return Object.values(DeliveryFunnelGate).includes(value);
}
function isDeliveryHealthReason(value) {
    return Object.values(pipeline_ops_1.DeliveryHealthReason).includes(value);
}
function isDeliverySlaSource(value) {
    return Object.values(DeliverySlaSource).includes(value);
}
function isDeliveryDatasheetCoverageJudgment(value) {
    return Object.values(DeliveryDatasheetCoverageJudgment).includes(value);
}
//# sourceMappingURL=delivery-health.js.map